export const EndPoint = {
    login: '/v1/login',
    //ripeness

    // GET  현재 이미지 조회
    validPicture: '/v2/valid',
    putvalidPicture: '/v1/valid',
    v3ValidPicture: '/api/v3/valid',

    //GET 다음 이미지 조회
    nextValidPicture: '/v2/valid/next/:id',
    v3NextValidPicture: '/api/v3/valid/next/:id',

    //GET  이전 이미지 조회
    prevValidPicture: '/v2/valid/prev/:id',
    v3PrevValidPicture: '/api/v3/valid/prev/:id',

    deletePicture: '/v1/picture/:id',
    reconfirmPicture: '/v1/reconfirm',
    prevReconfirmPicture: '/v1/reconfirm/prev/:id',
    nextReconfirmPicture: '/v1/reconfirm/next/:id',

    // estateList: "/v2/estates",
    // userList: "/v2/users",
    estateList: '/api/:version/estates',
    userList: '/api/:version/users',

    apk: '/apk',
};

export const DashboardEndPoint = {
    estateChart: 'v1/picture/stat/date?startDate=:start&endDate=:end',
    estateTable: 'v1/picture/stat/estate?startDate=:start&endDate=:end',
    userTable: 'v1/picture/stat/member?startDate=:start&endDate=:end',
    estateList: 'v1/picture/stat/estate?startDate=:start&endDate=:end',
};
